// extracted by mini-css-extract-plugin
export default {"TouchModal":"TouchModal_TouchModal__6h1fT","isOpen":"TouchModal_isOpen__eL1UR","Wrapper":"TouchModal_Wrapper__klv9f","isTouchModalOpen":"TouchModal_isTouchModalOpen__k-xCu"};